<template>
  <MainLayout>
    <ContentPageHeader functionName="棚卸管理" pageName="実施棚卸">
    </ContentPageHeader>
    
    <div class="search-section" @keyup.enter="handleSearch()">
      <div class="search-form">
        <FormDualComponent>
          <template #left>
            <FormYearMonthField
              id="searchYearMonth"
              label="対象年月"
              required
              v-model="searchForm.yearMonth"
              :min="constants.START_INVENTORY_CURRENT_SYSTEM"
            />
          </template>
          <template #right>
            <FormSelectSearchField
              id="searchStore"
              label="対象店舗"
              required
              v-model="searchForm.storeId"
              :options="storeOptions"
            />
          </template>
        </FormDualComponent>
      </div>
    </div>
    <div class="search-buttons-section">
      <div class="search-buttons">
        <button class="btn btn-primary" @click="handleSearch()">検索</button>
      </div>
    </div>

    <div v-if="showResults" class="card">
      <div class="card-body">
        <InventoryImplementationTable
          :items="tableItems"
          :columns="columns"
          :summaryData="summaryData"
        />
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import FormYearMonthField from '@/components/form/FormYearMonthField.vue'
import FormSelectSearchField from '@/components/form/FormSelectSearchField.vue'
import InventoryImplementationTable from './InventoryImplementationTable.vue'
import service from '../../services/service';
import constants from '../../constants/constants.json';
import { showLoading, hideLoading } from '@/utils/loadingEventBus';
import FormDualComponent from '@/components/form/FormDualComponent.vue'

export default {
  name: 'InventoryImplementationView',
  components: {
    MainLayout,
    ContentPageHeader,
    FormYearMonthField,
    FormSelectSearchField,
    FormDualComponent,
    InventoryImplementationTable
  },
  data() {
    return {
      constants,
      searchForm: {
        yearMonth: '',
        storeId: ''
      },
      storeOptions: [],
      categoryList: [],
      tableItems: [],
      summaryData: null,
      showResults: false,
      columns: [
        { key: 'categoryNo', label: 'カテゴリNo.', minWidth: 100, maxWidth: 150 },
        { key: 'categoryName', label: 'カテゴリ名称', minWidth: 180, maxWidth: 250 },
        { key: 'previousPeriodEnd', label: '', minWidth: 120, maxWidth: 160 },
        { key: 'month1', label: '1月末', minWidth: 80, maxWidth: 160 },
        { key: 'month2', label: '2月末', minWidth: 80, maxWidth: 160 },
        { key: 'month3', label: '3月末', minWidth: 80, maxWidth: 160 },
        { key: 'month4', label: '4月末', minWidth: 80, maxWidth: 160 },
        { key: 'month5', label: '5月末', minWidth: 80, maxWidth: 160 },
        { key: 'month6', label: '6月末', minWidth: 80, maxWidth: 160 },
        { key: 'month7', label: '7月末', minWidth: 80, maxWidth: 160 },
        { key: 'month8', label: '8月末', minWidth: 80, maxWidth: 160 },
        { key: 'month9', label: '9月末', minWidth: 80, maxWidth: 160 },
        { key: 'month10', label: '10月末', minWidth: 80, maxWidth: 160 },
        { key: 'month11', label: '11月末', minWidth: 80, maxWidth: 160 },
        { key: 'currentPeriodEnd', label: '', minWidth: 80, maxWidth: 150 }
      ],
    }
  },
  async mounted() {
    await this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
      try {
        showLoading();
        // 店舗情報とカテゴリ情報を取得
        const [storeResponse, categoryResponse] = await Promise.all([
          service.getStoreList(),
          service.getCategoryList()
        ]);
        this.storeOptions = storeResponse.data.stores.map(store => ({
          value: store.id,
          label: store.storeName
        }));
        this.categoryList = categoryResponse.data.categories;
        
      } catch (error) {
        console.error('初期データの取得に失敗しました:', error);
        alert('初期データの取得中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    
    async handleSearch() {
      if (!this.searchForm.yearMonth) {
        alert('年月は必須です');
        return;
      }
      if (!this.searchForm.storeId) {
        alert('店舗は必須です');
        return;
      }
      
      try {
        showLoading();
        // 実施棚卸データを取得
        const response = await service.getInventoryImplementation({
          yearMonth: this.searchForm.yearMonth,
          storeId: this.searchForm.storeId
        });
        this.tableItems = response.data.items;
        this.summaryData = response.data.summaryData;
        this.updateColumnsForPeriod();
        this.showResults = true;
        
      } catch (error) {
        console.error('実施棚卸データの取得に失敗しました:', error);
        alert('棚卸情報取得中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    
    updateColumnsForPeriod() {
      // 年月から年と期末期首を計算
      const yearMonth = this.searchForm.yearMonth;
      if (!yearMonth) return;
      const year = parseInt(yearMonth.substring(0, 4));
      const period = year - constants.ESTABLISHMENT_YEAR;
      
      // 前期末今期首のヘッダーを設定
      this.columns[2].label = (period - 1) + '期末<br/>' + period + '期首';
      this.columns[14].label = period + '期末';
    }
  }
}
</script>

<style scoped>
</style>
